import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { App } from 'src/app/models/app.model';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';
import { MaskStringPipe } from 'src/pipes/mask-string.pipe';

@Component({
  selector: 'apps-mobile',
  standalone: true,
  imports: [ButtonModule, MaskStringPipe],
  templateUrl: './apps-mobile.component.html',
})
export class AppsMobileComponent {
  loading = [false, false, false, false];

  private router = inject(Router);
  private sidebarMenuService = inject(SideBarMenuService);

  @Input()
  app: App;

  load(index: number) {
    this.loading[index] = true;
    setTimeout(() => (this.loading[index] = false), 1000);
  }

  navigateToMaiDetailApp() {
    this.sidebarMenuService.onLinkClicked(this.app);
    this.router.navigate(['/app']);
  }
}
